<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M31.11 8.5A10.5 10.5 0 0012 14.41a8.24 8.24 0 108.5 14.08v14a1.5 1.5 0 003 0v-6.92L27.57 31a11.29 11.29 0 003.43.5 11.5 11.5 0 00.11-23zM23.5 31v-2.33a10.29 10.29 0 001.25.95zm7.5-2.5a7.85 7.85 0 01-1.19-.09l.81-.92a1.49 1.49 0 10-2.24-2l-1.62 1.82a8.51 8.51 0 01-3.26-3.39V18a1.5 1.5 0 00-3 0v6a5.24 5.24 0 11-6.5-7.21l1.11-.38-.11-1.18a5.85 5.85 0 010-.73 7.5 7.5 0 0114-3.72l.46.82 1.06-.08h.47a8.5 8.5 0 010 17z"/></svg>